<template>
  <div class="viewContent">
    <div id="content1" :style="{height:portHeight + 'px'}">
      <!-- 轮播图 -->
      <Carousel
        :autoplay="autoplay"
        :autoplay-speed="5000"
        dots="inside"
        :radius-dot="true"
        class="carousel"
      >
        <!-- :style="{width:portWidth}" -->
        <CarouselItem>
          <div class="item3" :style="{height:portHeight + 'px'}">
            <div class="item3__title">为结构设计、施工、运维提供咨询服务</div>
            <div class="item3__title">用信息化技术让结构管养更<span>高效</span></div>
            <div class="item3__des">Providing Professional Consulting Services</div>
            <div class="item3__des">
              For Structural Design, Construction, Operation And Maintenance
            </div>
            <div class="item3__des">Using Information Technology</div>
            <div class="item3__des">
              To Make Structure Management And Maintenance More <span>Efficient</span>
            </div>
          </div>
        </CarouselItem>
        <CarouselItem v-if="hasnews">
          <div
            class="item2"
            :style="{
              backgroundImage: 'url(' + newsimage + ')',
              position: 'relative',
              paddingLeft: '0px',
              height: portHeight + 'px'
            }"
            @click="linkToNewNav('new_News')"
          >
            <div
              style="backdrop-filter:blur(10px);background-color:rgba(0,0,0,0.5);width: 100%;height: 100%;"
            >
              <img
                :src="newsimage"
                style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width: 80%;"
              />
            </div>
          </div>
          <!-- <div class="item2" @click="linkToNewNav('new_News')">
            <div
              style="backdrop-filter:blur(10px);background-color:rgba(255,255,255,0.6);width: 100%;"
              :style="{height:portHeight}"
            >
            <div style="width:100%;height:50px;position:absolute;bottom:50px;left:0;background-color: rgba(255,255,255,0.6);font-size:20px;line-height:50px;color:#515a6e;text-align:center;z-index:2;">
              {{newsIntro}}
            </div>
            <div style="position:absolute;left:50%;top:44%;transform:translate(-50%, -50%);width:100%;height:calc(100% - 100px);">
              <img :src="newsimage" alt="新闻图片" style="width:100%;">
            </div>
            </div>
          </div> -->
        </CarouselItem>
      </Carousel>
    </div>
    <div id="content2" :style="{height:portHeight + 'px'}">
      <div class="tabsBox">
        <ul>
          <li v-for="(item,index) in producetList" :key="item.key" :class="index==achKey?'tabsActived':'tabs'" @click="tab1Click(index)">
            <div>
              <img :src="item.img">
              <span>{{item.title}}</span>
            </div>
          </li>
        </ul>
      </div>
      <div class="tabsContent" :style="{'background-image':'url('+producetList[achKey].area[achKey2].bgImg+')'}">
        <div class="contentBox">
          <p v-for="ele in producetList[achKey].des" :key="ele" class="p1">{{ele}}</p>
          <!-- <div class="tabsBox2">
            <ul>
                <li v-for="(item,index) in producetList[achKey].area" :key="index" :class="achKey2==index?'tabs2Actived':'tabs2'" @click="achKey2=index">{{item.title}}</li>
            </ul>
          </div> -->
          <p class="p2">{{producetList[achKey].area[achKey2].describe}}</p>
          <Button class="moreInfo">
            了解更多
            <Icon type="md-open" />
          </Button>
        </div>
        <div class="tabs_vert">
          <ul>
            <li v-for="(item,index) in producetList[achKey].area" :key="index" :class="achKey2==index?'on':'off'" @click="achKey2=index">{{item.title}}</li>
          </ul>
        </div>
        <!-- <div class="achImgBox">
          <img :src="producetList[achKey].area[achKey2].img" alt="" class="achImg">
        </div> -->
      </div>
    </div>
    <div id="content3" :style="{height:portHeight + 'px'}">
      <div class="c3head">
        <span class="title">业绩成果</span>
        <!-- <Button class="moreInfo">
          了解更多
          <Icon type="md-open" />
        </Button> -->
      </div>
      <div class="coordinBox">
        <ul :style="{height:imgHeight+'px'}">
          <li v-for="(item,index) in achList" :key="index" :class="achKey3==index?'on':'off'" @mouseenter="onMouseEnter(index)" @click="content3click(index)"> 
            <img :src="item.img" alt="" class="coordinImg" :style="{height:imgHeight+'px'}">
            <!-- <div class="coordinBgImg" :style="{backgroundImage: 'url('+item.img+')',height:imgHeight+'px'}"></div> -->
          </li>
        </ul>
      </div>
      <div class="c3NavBox">
        <div class="coordinContent" v-for="(item,index) in achList" :key="index" :class="achKey3==index?'ccOn':'ccOff'" @mouseenter="onMouseEnter(index)" @click="content3click(index)">
          <span class="span1">{{achKey3==index?item.title:item.class}}</span>
          <span class="span2">{{item.describe}}</span>
        </div>
        <!-- <Button id="c3Nav" style="left:20%;">
          {{achList[achKey3].class}}
          <Icon type="md-open" />
        </Button> -->
      </div>
    </div>
    <!-- <Anchor id="anchor" show-ink>
        <AnchorLink href="#content1" title="最新消息" />
        <AnchorLink href="#content2" title="业务介绍" />
        <AnchorLink href="#content3" title="业绩成果" />
    </Anchor> -->
  </div>
</template>
<script>
export default {
  name: "new_home",
  data() {
    return {
      achList: [
        {
          class: "工程结构仿真实例",
          key: "ana",
          title: "滨海湾大桥结构仿真分析",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach1.png", //"https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/newAch1.png",
          describe: "建立三维整体混合有限元模型，模型总自由度数达8000万，然后计算结构在恒载、收缩、徐变、温度、风荷载、活载等工况下关键构件和部位应力分布及混凝土内力分配关系，并分析多种疲劳荷载作用下关键结构部位的应力结果。"
        },
        {
          class: "工程结构仿真实例",
          key: "ana",
          title: "鹅公岩大桥抗震分析",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/newAch2.jpg",
            // "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/home_ach2.png"
          describe: "建立有限元模型，考虑大位移效应和应力刚化效应进行成桥状态分析，采用时域显式随机模拟法和反应谱CQC法计算大桥的结构地震响应。采用时域显式降维迭代-随机模拟法开展非线性随机地震响应分析，评价减震装置性能效果。并对大桥关键截面进行抗震性能验算，并给出大桥的抗震性能安全性评价。"
        },
        {
          class: "工程智能监测实例",
          key: "moni",
          title: "新光大桥施工监控",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeNewAche3.png",
          describe: "在新光大桥施工过程中对重要的结构设计参数和状态参数进行监测，以获得反映实际施工情况的数据和技术信息，不断根据实际情况调整施工状态参数，使各阶段的施工状态始终处于控制范围之内。"
        },
        {
          class: "工程智能监测实例",
          key: "moni",
          title: "鹤洞大桥健康监测",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/newAch4.jpg",
          describe: "基于既有桥梁实际运营状况和病害情况，在满足常规监测内容的基础上，开展部分针对性监测，重点关注局部病害和斜拉索索力，采用多种监测手段相互校核，提升监测效果，为桥梁运营管养决策提供技术支持。"
        },
        {
          class: "工程数字科技实例",
          key: "moni",
          title: "天空之城结构健康监测平台",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeNewAche5.png",
          describe: "天空之城结构健康监测平台，基于监测结构的独特性、复杂性和重要性，提供完善的综合性监测平台，适应项目结构监测的需求，实时响应运维阶段出现的状况并做出快速科学的决策。"
        },
        {
          class: "工程数字科技实例",
          key: "tech",
          title: "桥梁集群式健康监测运维平台",
          img: "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/newAch6-2.png",
          describe: "集群式健康监测运维平台可接入区域内多个监测项目，提供健全的运维功能和海量数据的应用管理服务，解决制约区域级监测的技术难题，提升监测效率，满足监测市场的需求和趋势发展。"
        },
      ],
      achKey: 0,
      achKey2: 0,
      producetList: [
        {
          key: "struct_analyse",
          bgImg:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg1.jpg",
          img:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/ana_icon2.png",
          title: "工程结构仿真",
          des: ["基于自研算法分析软件开展工程结构精细化仿真分析，","为结构在设计、施工以及运营阶段所涉及的关键技术问题提供精准分析解决方案"],
          area: [
            {
              title: '结构精细仿真',
              key: 0,
              describe: '建立结构三维精细化有限元模型，获取结构更为丰富的分析结果，可以更加准确评估结构的强度和刚度。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area00.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg00.png'
            },
            {
              title: '结构抗震分析',
              key: 1,
              describe: '针对桥梁、高层建筑、核电工程结构等大型复杂结构，采用非平稳随机振动方法开展结构抗震与减隔震分析。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area01.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg01.png'
            },
            {
              title: '结构减振分析',
              key: 2,
              describe: '分析结构在各种随机动力荷载作用下的响应，评估结构的安全性和舒适性，继而开展结构减振措施研究。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area02.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg02.png'
            },
            {
              title: '既有结构评估',
              key: 3,
              describe: '结合既有结构的安全性检测，建立符合结构现状的分析模型，评估结构的安全性和提出相关的加固处理建议。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area03.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg03.png'
            },
            {
              title: '结构优化分析',
              key: 4,
              describe: '建立结构参数化分析模型，结合多种优化分析算法，开展结构在确定性荷载或者随机荷载作用下的拓扑或参数优化分析。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area03.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg04.png'
            },
            {
              title: '结构抗风分析',
              key: 5,
              describe: '结合随机风场模拟和风荷载计算等技术，对建筑和桥梁等结构开展结构抗风随机分析和有效降低风致振动措施研究 。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area03.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg05.png'
            },
            {
              title: '结构疲劳分析',
              key: 6,
              describe: '基于可靠性理论和疲劳基本理论，开展结构的疲劳分析工作，对既有结构进行疲劳寿命预测和可靠度评估。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area03.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg06.png'
            },
            {
              title: '施工过程仿真',
              key: 7,
              describe: '考虑结构实际的施工过程，定义结构施工阶段，分析与评估每个施工阶段结构的安全性和可靠性。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area03.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg07.png'
            },
          ]
        },
        {
          key: "struct_moni",
          bgImg:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg2.jpg",
          img:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/moni_icon2.png",
          title: "工程智能监测",
          des: ["基于自主监测算法，融合智能传感、无线通信、云计算、人工智能等新型监测技术，","为大型复杂工程全寿命周期的质量安全提供可靠的技术保障"],
          area: [
            {
              title:'结构施工监控',
              key: 0,
              describe: '对于分阶段施工的大型复杂结构，应进行施工全过程的监测与控制，以确保施工过程中结构受力安全，及时消除施工过程中的偏差，最终保障结构竣工后的构形与内力状态满足设计要求。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area10.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg10.png'
            },
            {
              title:'结构健康监测',
              key: 1,
              describe: '对于既有工程结构，通过自动化监测手段获取环境作用和结构响应信息，科学制定各类阈值并实现动态预警，定期更新结构安全评估和寿命预测，为结构运营维护及加固设计、施工提供科学的决策依据。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area11.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg11.png'
            },
            {
              title:'结构检测鉴定',
              key: 2,
              describe: '通过测试工程结构的各种工作性能参数或实际破坏形态，评定结构刚度、抗裂度、裂缝状态、强度、承载力、稳定和耗能能力等参数，评价结构实际性能状态，并验证结构计算理论。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area12.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg12.png'
            }
          ]
        },
        {
          key: "struct_tech",
          bgImg:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/homeBusiness_bg3.jpg",
          img:
            "https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/tech_icon2.png",
          title: "工程数字科技",
          des: ["促进新基建与传统基础设施融合赋能，","实现土木行业智能化重塑"],
          area: [
            {
              title:'工程安全监测平台',
              key: 0,
              describe: '深度融合Cloud和BIM技术，为建筑和桥梁工程施工、使用期监测系统监控平台提供软件研发和升级维护。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area20.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg20.png'
            },
            {
              title:'监测大数据应用平台',
              key: 1,
              describe: '自主研发粤桥云平台满足区域级多桥梁健康监测系统集中管控和运维需求，为海量监测数据挖掘提供专业和强大的算力支撑。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area21.png',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg21.png'
            },
            {
              title:'计算机视觉技术应用',
              key: 2,
              describe: '基于计算机视觉技术，在结构外观病害识别、索力测试、车流时空分布监测、实景三维与BIM融合等方面得到应用。',
              img: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/area22.jpg',
              bgImg: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/c2bg22.png'
            }
          ]
        }
      ],
      achKey3: 0,
      cur_index: 0,
      invoke: false,
      list: [],
      isinit: false,
      autoplay: true,
      hasnews: true,
      newsimage: 'https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/news1Image.png',
      newsIntro: '喜报！粤桥公司荣获 “高新技术企业” 认定',
      portHeight: '700',
      portWidth: '1920px'
    };
  },
  // watch:{
  //   achKey3(index){
  //     document.querySelector('#coordinContent').style.left = (0 + index*12) + '%'
  //   }
  // },
  computed: {
    isMobile() {
      if (
        window.navigator.userAgent.match(
          /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
        )
      ) {
        return true;
      } else {
        return false;
      }
    },
    currRem(){
      return Math.ceil(document.body.clientWidth / 24)
    },
    imgHeight(){
      return this.portHeight - 2.25*this.currRem
    }
  },
  created() {
    this.$emit("changeProduce", "new_home");
    this.isinit = false;
    // this.portHeight = this.isMobile?'80vh':'100vh'
    this.calcHeight()
  },
  mounted() {
    this.calcWidth()
    const _this = this;
    // window.location.reload()
    window.addEventListener('scroll', this.WheelGo, { passive: false })
    // this.list = [
    //   { ele: 'carousel' },
    //   { ele: 'describe' },
    //   { ele: 'product' },
    //   { ele: 'projectList' },
    //   // { ele: 'projectList2' },
    //   // { ele: 'partner' },
    //   { ele: 'footer' }
    // ]
    // document.querySelector('body').addEventListener('mouseover' ,this.initSrollPosition)
    // // this.list = this.initSrollPosition('body', this.list)
    // let carousel = document.getElementsByClassName('carousel')[0]
    // carousel.onmouseover = function() {
    //   _this.$emit('back',false)
    // }
    // carousel.onmouseout = function() {
    //   _this.$emit('back',true)
    // }
    // setTimeout(() => {
    //   document.querySelector('#anchor .ivu-anchor-link').classList.add('ivu-anchor-link-active')
    // }, 50);
  },
  methods: {
    handleOpenPages(val) {
      window.open(val);
    },
    // 跳转产品中心子菜单
    linkToNewNav(val) {
      this.$emit("changeProduce", val);
    },
    linkToProjectlist(id) {
      this.$emit("changeProduce", "nprojectList", id);
    },
    toPlatform() {
      window.open("https://cloud.yueq.com.cn/");
    },
    initSrollPosition() {
      if (!this.isinit) {
        for (let i in this.list) {
          this.list[i].position = document.querySelector(
            "." + this.list[i].ele
          ).offsetTop;
        }
        this.isinit = true;
      }
    },
    stopDefault(e) {
      e.preventDefault();
      return false;
    },
    WheelGo(e) {
      let offset1 = 0
      let offset2 = document.querySelector('#content2').offsetTop /// window.devicePixelRatio
      let offset3 = document.querySelector('#content3').offsetTop /// window.devicePixelRatio
      // console.log(window.devicePixelRatio * window.pageYOffset)
      // console.log(document.querySelector('#content2').offsetTop)
      if(window.pageYOffset === offset1){
        this.$emit('anchorIndex', 1)
      }
      else if(window.pageYOffset >= offset2 && window.pageYOffset < offset3){
        this.$emit('anchorIndex', 2)
      }
      else if(window.pageYOffset >= offset3){
        this.$emit('anchorIndex', 3)
      }
      else{
        this.$emit('anchorIndex', 1)
      }
      // if(window.pageYOffset === 0){
      //   setTimeout(() => {
      //     document.querySelector('#anchor .ivu-anchor-link').classList.add('ivu-anchor-link-active')
      //   }, 50);
      // }
      // else if(window.pageYOffset >= document.querySelector('#content2').offsetTop){
      //   document.querySelector('#anchor .ivu-anchor-link').classList.remove('ivu-anchor-link-active')
      // }
      // 判断向上滚动还是向下滚动
      // var isDown = e.deltaY > 0 ? true : false;

      // this.stopDefault(e);
      // if (this.invoke) {
      //   return;
      // }
      // this.moveTo(isDown);
    },
    moveTo(isDown) {
      var cur_state;
      if (isDown) {
        this.cur_index =
          this.cur_index >= this.list.length - 1
            ? this.list.length - 1
            : this.cur_index + 1;
        cur_state = this.list[this.cur_index];
      } else {
        this.cur_index = this.cur_index <= 0 ? 0 : this.cur_index - 1;
        cur_state = this.list[this.cur_index];
      }
      // console.log("invoke")
      // console.log(this.list)
      this.invoke = true;
      // console.log(this.cur_index)
      window.scrollTo({ top: cur_state.position, left: 0, behavior: "smooth" });
      if (this.cur_index == 2) {
        document
          .querySelector(".header_name")
          .setAttribute("style", "color:#000;");
        document
          .querySelector(".selected")
          .setAttribute("style", "color:#000;");
        // console.log(document.querySelector('.header_name'))
      } else {
        document
          .querySelector(".header_name")
          .setAttribute("style", "color:#FFF;");
        document
          .querySelector(".selected")
          .setAttribute("style", "color:#FFF;");
      }
      // if(this.cur_index == 0){
      //   document.querySelector('.header--home').setAttribute('position', 'absolute')
      // }
      // else{
      //   document.querySelector('.header--home').setAttribute('position', 'fixed')
      // }
      setTimeout(() => {
        this.invoke = false;
      }, 500);
    },
    tab1Click(index){
      this.achKey = index
      this.achKey2 = 0
    },
    onMouseEnter(index){
      this.achKey3 = index
    },
    calcHeight(){
      let height = document.body.clientHeight
      let width = document.body.clientWidth
      let min = this.currRem*10.125//(815 / window.devicePixelRatio)
      let stand = parseInt((9 * width) / 16)//16:9标准画幅
      // console.log(height)
      if(height < min){
        height = min
      }
      else if(height > stand){
        height = stand
      }
      this.portHeight = (height - this.currRem)
      // console.log(height)
      // console.log(this.currRem)
      // console.log(this.portHeight)
    },
    calcWidth(){
      let width = document.body.clientWidth
      this.portWidth = width + 'px'
      // if(width < 960){
      //   window.body.width = 960 + 'px'
      // }
    },
    content3click(index){
      this.achKey3 = index
      this.$emit('changeProduce', 'newprojectList', null, null)
    }
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.WheelGo)
    // document.querySelector('body').removeEventListener('mouseover',this.initSrollPosition)
  }
};
</script>
<style lang="less" scoped>
// @media all
// and (-moz-device-pixel-ratio: 2.00),
//     (-webkit-device-pixel-ratio: 2.00),
//     (resolution: 200dpi){
//   .tabsContent{
//     background-position: 100% 70% !important;
//   }
// }
.viewContent {
  height: 100%;
  // min-width: 1300px;
  position: relative;
  #content1,
  #content2,
  #content3,
  #content4 {
    width: 100%;
    // padding: 10px 0;
    ul,li{
      margin: 0;
      padding: 0;
      list-style: none;
    }
  }
  .carousel {
    .item2 {
      width: 100%;
      background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/carousel2.png")
        center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      cursor: pointer;
      &__title {
        font-size: 0.27rem;//30px
        line-height: 1.5em;
        font-weight: 400;
        font-family: SourceHanSansCN-Bold, SourceHanSansCN;
        letter-spacing: 3px;
      }
      &__des {
        font-size: 0.3rem;//24px
        line-height: 1.5em;
      }
      &__des span {
        color: #2d8cf0;
      }
    }
    .item3 {
      width: 100%;
      height: 100%;
      background: url("https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/carousel2.png")
        center center no-repeat;
      background-size: 100% 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      color: #fff;
      &__title {
        font-size: 0.6rem;//48px
        line-height: 1.5em;
        font-weight: 400;
        margin-bottom: 0.6rem;//48px
      }
      &__title span {
        color: #2d8cf0;
      }
      &__des {
        font-size: 0.2rem;//16px
        line-height: 1.5em;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        letter-spacing: 0.2em;
      }
      &__des span {
        color: #2d8cf0;
      }
    }
  }
  #content2 .tabsBox{
    width: 100%;
    height: 1.125rem;//90px
    ul{
      display: flex;
      justify-content: center;
      height: 100%;
      li{
        display: flex;
        width: 3.5rem;//280px
        height: 100%;
        justify-content: center;
        align-items: center;
        margin: 0 0.125rem;//10px
        // padding: 5px 10px;
        transition: 0.3s all;
        cursor: pointer;
        z-index: 1;

        div{
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: fit-content;
          height: 100%;
          img{
            display: block;
            width: 1rem;
            height: 0.75rem;
            // margin-bottom: 10px;
          }
          span{
            display: block;
            height: 2em;
            line-height: 2em;
            font-size: 0.25rem;
            text-align: center;
          }
        }
      }
      li:hover{
        transform: scale(1.1);
      }
      li::before{
        content: "";
        display: block;
        height: 0.0625rem;//5px
        background: #2d8cf0;
        position: absolute;
        bottom: 0px;
        left: 0;
        width: 0;
        transition: all .3s;
        z-index: 2;
      }
      li.tabs{
        box-shadow: none;
        font-weight: 300;
      }
      li.tabsActived{
        transform: scale(1);
        font-weight: bold;
        box-shadow: 0 0 10px rgba(0,0,0,0.3);
      }
      li.tabsActived::before{
        width: 100%;
      }
    }
  }
  #content2 .tabsContent{
    height: calc(100% - 1.125rem);
    // margin-top: 5px;
    background-size: cover;
    background-position: 100% 100%;
    background-repeat: no-repeat;
    position: relative;
    overflow: hidden;
    .contentBox{
      top: 10%;
      width: 50%;
      position: relative;
      left: 3.5rem;//270px
      font-size: 0.2rem;//16px
      .p1{
        line-height: 1.5em;
        font-weight: bold;
        font-size: 0.3rem;//24px
      }
      .p2{
        color: #2d8cf0;
        line-height: 1.5em;
        font-weight: 400;
        font-size: 0.25rem;//20px
        margin-top: 2.5em;
      }
    }
      .tabs_vert{
        display: block;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        ul{
          display: flex;
          width: max-content;
          height: 100%;
          flex-direction: column;
          flex-wrap: wrap;
          justify-content: flex-start;
          // box-shadow: 0 10px 10px rgba(0,0,0,0.2);
          // background-color: rgba(255, 255, 255, 0.4);
          li{
            transition: all 0.6s;
            padding: 0 0.125rem;
            width: 2.5rem;//200px
            height: 4em;//80px
            line-height: 4em;//80px
            position: relative;
            font-size: 0.25rem;//20px
            color: #333;
            text-align: center;
            align-items: center;
            cursor: pointer;
          }
          li::before{
            content: "";
            display: block;
            height: 0.0625rem;//5px
            background: #2d8cf0;
            position: absolute;
            bottom: 0px;
            left: 0;
            width: 0;
            transition: all .3s;
            z-index: 2;
          }
          li.off{
            width: 2.5rem;
          }
          li.on{
            font-weight: bolder;
            // border-bottom: 5px solid #12639E;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
            width: 2.75rem;//220px
            background-color: rgba(255, 255, 255, 0.6);
          }
          li.on::before{
            width: 100%;
          }
          li:hover{
            font-weight: bolder;
            // border-bottom: 5px solid #12639E;
            box-shadow: 0 0 10px rgba(0,0,0,0.3);
            width: 2.75rem;//220px
            background-color: rgba(255, 255, 255, 0.6);
          }
        }
      }
    .moreInfo{
      // position: absolute;
      // bottom: 10px;
      // left: 5%;
      margin-top: 4em;
      // animation: animated-border 2s infinite;
    }
  }
  #content3{
    position: relative;
    ul,li{
      margin: 0;
      padding: 0;
      list-style: none;
    }
    .c3head{
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: center;
      align-items: center;
      width: 100%;
      height: 1rem;//80px
      position: relative;
      .title{
        display: block;
        height: 1rem;
        line-height: 1rem;
        font-size: 0.4rem;
        text-align: center;
        font-weight: bold;
        position: relative;
      }
      .title::before{
        content: "";
        display: block;
        height: 0.0625rem;//5px
        background: #2d8cf0;
        position: absolute;
        bottom: 0.125rem;
        left: 50%;
        width: 2em;
        transform: translateX(-50%);
        transition: all .3s;
      }
    }
    .c3NavBox{
      position: relative;
      width: 100%;
      // height: 50px;
      height: 1.25rem;//100px
      display: flex;
      flex-direction: row;
      flex-wrap: nowrap;
      overflow: hidden;
      // margin: 10px 0;
      #c3Nav{
        display: block;
        width: fit-content;
        height: 100%;
        border-radius: 15px;
        background-color: #2d8cf0;
        // padding: 20px 16px;
        color: #FFF;
        text-align: center;
        font-size: 0.25rem;//20px
        position: absolute;
        top: 0;
        transform: translateX(-50%);
        transition: all 0.6s;
      }
    }
    .coordinBox{
      ul{
        width: 100%;
        height: calc(100% - 1.25rem - 1rem);
        display: flex;
        flex-wrap: wrap;
        position: relative;
        li{
          transition: all 0.6s;
          // border: 1px solid #000;
          position: relative;
          flex: 0 0 auto;
          flex-grow: 0;
          flex-shrink: 0;
          flex-basis: unset;
          cursor: pointer;
        }
        .coordinImg{
          overflow: clip;
          overflow-clip-margin: content-box;
          display: inline;
          object-fit: cover;
          vertical-align: middle;
          height: 100%;
          width: 100%;
          z-index: 1;
          -webkit-mask-image: linear-gradient(to left, transparent 1px, #fff 20px);
        }
        .coordinBgImg{
          height: 100%;
          width: 100%;
          background-size: auto 100%;
          background-repeat: no-repeat;
          background-attachment: local fixed;
          // background-position: 20% 100%;
          z-index: 1;
          -webkit-mask-image: linear-gradient(to left, transparent 1px, #fff 20px);
          transition: all 1s;
        }
        li.off{
          width: 10%;
        }
        li.on{
          width: 50%;
          .coordinBgImg{
            background-size: 100% 100%;
          }
        }
      }
    }
    .coordinContent{
      display: flex;
      // display: block;
      background-image: linear-gradient(0.0deg, rgba(0, 99, 176, 1) 0.0, rgba(0, 153, 226, 1) 100%);
      flex-wrap: wrap;
      flex-direction: row;
      height: 100%;
      // background-color: rgba(240, 130, 0, 0.8);
      position: relative;
      z-index: 2;
      // border-top-left-radius: 15px;
      // border-top-right-radius: 15px;
      margin-top: 0px;
      transition: all 0.6s;
      overflow: hidden;
      .span1{
        color: rgba(255, 255, 255, 1);
        font-size: 0.3rem;//
        line-height: 1.5em;
        font-weight: bold;
        width: 100%;
        // margin-bottom: 10px;
      }
      .span2{
        font-size: 0.18rem;
        color: rgba(255, 255, 255, 0.66);
        line-height: 1.5em;
        -webkit-line-clamp: 4;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
      .moreInfo{
        position: relative;
      }
    }
    .ccOn{
      width: 50%;
      background-image: linear-gradient(0.0deg, rgba(0, 99, 176, 1) 0.0, rgba(0, 153, 226, 1) 100%);
      padding: 0px 0.5625rem;
    }
    .ccOn>.span1{
      color: rgba(255,255,255,1);
    }
    .ccOn>.span2{
      color: rgba(255,255,255,0.66);
      // display: -webkit-box;
    }
    .ccOff{
      width: 10%;
      height: 1.25rem;//100px
      background-image: none;
      // padding: 0;
    }
    .ccOff>.span1{
      color: rgba(0, 0, 0, 0.6);
      // display: none;
      // -webkit-line-clamp: 2;
      // display: -webkit-box;
      -webkit-box-orient: vertical;
      overflow: hidden;
      display: block;
      width: 4em;
      margin: 0 auto;
      text-align: center;
    }
    .ccOff>.span2{
      color: rgba(0, 0, 0, 0);
      display: none;
    }
  }
  .moreInfo{
    position: relative;
    display: block;
    background-color: #2d8cf0;
    outline: none;
    border: none;
    color: #fff;
    height: 2em;
    font-size: 0.2rem;//16px
    margin: 10px 0;
  }
  .moreInfo:hover{
    transition: all 0.3s;
    transform: scale(1.1);
  }
}
/deep/ .ivu-carousel-arrow{
  width: 0.8rem;//64px
  height: 0.8rem;
  font-size: 0.6rem;//48px
}
/deep/ .ivu-carousel-dots li button.radius{
  width: 0.2rem;//16px
  height: 0.2rem;
}
/deep/ .ivu-carousel-dots-inside{
  bottom: 0.25rem;//20px
}
</style>
